import { render, staticRenderFns } from "./UpdateRateDialog.vue?vue&type=template&id=4fcf91e2"
import script from "./UpdateRateDialog.vue?vue&type=script&lang=js"
export * from "./UpdateRateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports